"use client"

import { usePathname, useRouter } from 'next/navigation'
import React from 'react'

const Policy = () => {
    
    const router = usePathname()
 
 return <div style={{display: "flex", flexDirection: "column", gap: 20}}>
        <h1 style={{padding: 0}} className='politics__list-title'>Связанные документы</h1>
        
        {router?.includes('about') ? ''  : <a href={"/about-cookie"}>Что такое файлы cookie, и как мы их используем</a>}    
        {router?.includes('user') ? ''  : <a href={"/user-confidential"}>Согласие на обработку персональных данных</a>}    
        {router?.includes('cookie') && !router?.includes('about') ? ''  : <a href={"/cookie"}>Согласие на обработку персональных данных «Cookie»</a>}    
        {router?.includes('confidential') ? ''  : <a href={"/confidential"}>Политика обработки и защиты персональных данных</a>}    
    </div>
}

export default Policy